// @flow

export {Rating, Rating as default} from './components/rating';
export {StarsRating} from './components/stars-rating';
export {Themes, Sizes} from './constants';

export type {Theme, Size} from './constants';
export type {OnChangeRating} from './typedef';

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");

require("./typedef");

require("./components/rating");

require("./components/stars-rating");
